import React from 'react';
import './App.css';
if (localStorage.getItem('sm-theme') === 'light') document.documentElement.classList.add('light');
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { AuthProvider, useAuth } from './context/AuthContext';
import { I18nProvider } from './context/I18n';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardLayout from './pages/DashboardLayout';
import Overview from './pages/Overview';
import Estoque from './pages/Estoque';
import Crm from './pages/Crm';
import Equipe from './pages/Equipe';
import Bdc from './pages/Bdc';
import Clientes from './pages/Clientes';
import Agenda from './pages/Agenda';
import Chat from './pages/Chat';
import Reports from './pages/Reports';
import Admin from './pages/Admin';
import { Finance, Recon, Documents } from './pages/Modules';
import TradeIn from './pages/TradeIn';
import Financeiro from './pages/Financeiro';
import PostSale from './pages/PostSale';
import Tasks from './pages/Tasks';
import Notas from './pages/Notas';
import FiDeals from './pages/FiDeals';
import ServiceDelivery from './pages/ServiceDelivery';
import DetailShop from './pages/DetailShop';
import Profile from './pages/Profile';
import LandingPages from './pages/LandingPages';
import Integrations from './pages/Integrations';
import PublicLanding from './pages/PublicLanding';

function HomeRoute() {
  const { user } = useAuth();
  if (user?.role === 'Detail') return <Navigate to="/app/detail" replace />;
  const landing = user?.prefs?.landing;
  if (landing && landing !== '/app') return <Navigate to={landing} replace />;
  return <Overview />;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<HomeRoute />} />
        <Route path="estoque" element={<Estoque />} />
        <Route path="bdc" element={<Bdc />} />
        <Route path="clientes" element={<Clientes />} />
        <Route path="crm" element={<Crm />} />
        <Route path="agenda" element={<Agenda />} />
        <Route path="chat" element={<Chat />} />
        {/* Módulo WhatsApp desativado (09/10/2026). Código preservado em pages/WhatsAppInbox.jsx,
            pages/WhatsAppDashboard.jsx e pages/mobile/MobileApp.jsx — basta religar estas rotas. */}
        <Route path="vendas" element={<Navigate to="/app/deals" replace />} />
        <Route path="deals" element={<FiDeals />} />
        <Route path="trade-in" element={<TradeIn />} />
        <Route path="finance" element={<Finance />} />
        <Route path="recon" element={<Recon />} />
        <Route path="service" element={<ServiceDelivery />} />
        <Route path="detail" element={<DetailShop />} />
        <Route path="profile" element={<Profile />} />
        <Route path="post-sale" element={<PostSale />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="notas" element={<Notas />} />
        <Route path="documents" element={<Documents />} />
        <Route path="financeiro" element={<Financeiro />} />
        <Route path="reports" element={<Reports />} />
        <Route path="equipe" element={<Equipe />} />
        <Route path="landing-pages" element={<LandingPages />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="admin" element={<Admin />} />
      </Route>
      <Route path="/lp/:slug" element={<PublicLanding />} />
      {/* PWA do WhatsApp desativada junto com o módulo. */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster />
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
